import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { WfAccessProvider } from 'wflow-security';
import { UserOrgAccountAPIService, UserRight } from '../api';

@Injectable()
export class RoleProviderService implements WfAccessProvider {
  constructor(private userAccountService: UserOrgAccountAPIService) {}

  getAccess(contextId: string): Observable<UserRight[]> {
    return this.userAccountService
      .getAccount(contextId)
      .pipe(map((res) => res?.rights ?? []));
  }
}
